import myRoleRoute from "../api/[orgId]/roles/current.route";
import updateRoleRoute from "../api/[orgId]/roles/update-user.route";
import { post } from "./lib";

export const getMyRole = (org_id: string) =>
  post<typeof myRoleRoute>(`/api/${org_id}/roles/current`);

export const updateUserRole = (org_id: string, user_id: string, role: string) =>
  post<typeof updateRoleRoute>(`/api/${org_id}/roles/update-user`, {
    editing_user_id: user_id,
    org_id,
    action: role,
  });
